import React from 'react';
import { Helmet } from 'react-helmet';

function SeoHead({ page }) {
  const socialImageUrl = new URL('/logo192.png', page.url).href;

  return (
    <Helmet>
      <title>{page.title}</title>
      <meta name="description" content={page.description} />
      <meta name="keywords" content={page.keywords} />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <link rel="canonical" href={page.url} />
      <meta property="og:type" content={page.ogType || 'website'} />
      <meta property="og:site_name" content="Hawktrion WhatsApp Business API" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      <meta property="og:url" content={page.url} />
      <meta property="og:image" content={socialImageUrl} />
      <meta property="og:image:alt" content={page.title} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description} />
      <meta name="twitter:image" content={socialImageUrl} />
      <meta name="twitter:site" content="@hawktrion" />
      <meta name="twitter:creator" content="@hawktrion" />
      <script type="application/ld+json" data-seo="structured-data">
        {JSON.stringify(page.structuredData)}
      </script>
    </Helmet>
  );
}

export default SeoHead;
